// src/polyfills.ts

if (!Array.prototype.at) {
    // eslint-disable-next-line 
    Array.prototype.at = function <T>(this: T[], index: number): T | undefined {
        if (this == null) {
            throw new TypeError("Array.prototype.at called on null or undefined");
        }
        const len = this.length;
        let k = Math.trunc(index) || 0;
        if (k < 0) k += len;
        if (k < 0 || k >= len) return undefined;
        return this[k];
    };
}

export { };
